const ActionType = {
    UPDATE_STATE: "UPDATE_STATE"
}
export default ActionType;